import CONSTANTS from "@/store/constants";
import filters from "@/filters/filter";
import {mapActions, mapGetters, mapMutations} from "vuex"
import FORM_LABELS from "@/store/FormLabels";
import swal from "sweetalert2";
import SendUserToSlackModal from "../components/SendUserToSlackModal";
import HeaderWithTooltip from "@/components/HeaderWithTooltip";
import PoFilterFAQModal from "@/components/PoFilterFAQModal";
import InvoicesPOFiltersMixin from "./InvoicesPOFiltersMixin";

export default {
    filters: filters,
    components: {HeaderWithTooltip},
    mixins: [InvoicesPOFiltersMixin],
    computed: {
        ...mapGetters(["currentUser","poFiltersList","prevRoute"]),
    },
    data() {
        return {
            FORM_LABELS: FORM_LABELS,
            detailModal: {
                titleClass: 'col-md-5 col-6 detail-label',
                descriptionClass: 'col-md-6 col-5'
            },
            invoiceDetailModal: {
                titleClass: 'col-md-4 detail-label',
                descriptionClass: 'col-md-8'
            },
            paginationOptions: {
                mode: "records",
                perPage: CONSTANTS.PAGINATION_THRESHOLD,
                perPageDropdown: [5, 10, 15],
                dropdownAllowAll: false,
                position: "bottom",
                nextLabel: "next",
                prevLabel: "prev",
                rowsPerPageLabel: "Rows per page",
                ofLabel: "of",
                pageLabel: "page", // for 'pages' mode
                allLabel: "All"
            }
        }
    },
    methods: {
        ...mapMutations(["setIsLoading","setViewingAPUserDataFor","setAPUserId"]),
        ...mapActions(["fetchPurchaseOrders","fetchInvoiceDashboardData"]),
        /*
            vue-good-table takes ~ 500-600ms to render UI if current user page number is set to > 1.
            This creates a stuttering effect on UI as user notices page number change.
            this is to wait for some time until UI is finished going to that page.
            Fix applies only if currentPage > 1, all other user prefs (Sorting, filtering, current per page) work fine.
        */
        waitForPaginationRender() {
            this.setIsLoading(true)
            let that = this
            setTimeout(() => {
                that.setIsLoading(false)
            }, CONSTANTS.VGT_PAGINATION_EXPLICIT_WAIT_IN_MILLIS)
        },
        routeToInvoices() {
            //Ignore navigationDuplicated as user intended to search same string and navigate again, else print exception
            /* eslint-disable no-console */
            let invoiceCategory = this.prevRoute.includes(CONSTANTS.INVOICES_TAB_ROUTES.ALL_INVOICES) ? CONSTANTS.INVOICES_TAB_ROUTES.ALL_INVOICES : CONSTANTS.INVOICES_TAB_ROUTES.INVOICES
            this.$router.replace({name: 'InvoiceCategory', params: { invoiceCategory: invoiceCategory }})
                .catch((ex) => { if(ex.name !== 'NavigationDuplicated') { console.error(ex) }})
        },
        routeToPurchaseOrders() {
            this.$router.push({name: "PurchaseOrders"})
                .catch((ex) => { if(ex.name !== 'NavigationDuplicated') { console.error(ex) }})
        },
        async updateImpersonationData(){
            this.setViewingAPUserDataFor(null);
            this.setAPUserId(null)
            await this.fetchInvoiceDashboardData()
            await this.fetchPurchaseOrders();
        },
        routeToAllInvoices(){
            if(this.$router.currentRoute.fullPath.includes(CONSTANTS.INVOICES_ROUTE)){
                this.$router.replace({name: 'InvoiceCategory', params: { invoiceCategory: CONSTANTS.INVOICES_TAB_ROUTES.ALL_INVOICES } })
                    .catch((ex) => {
                        if (ex.name !== 'NavigationDuplicated') {
                            console.error(ex)
                        }});
            }
        },
        async clickToViewYourInvoicesPO(){
            try{
                this.setViewingAPUserDataFor(null)
                this.setAPUserId(null)
                await this.fetchInvoiceDashboardData();
                await this.fetchPurchaseOrders();
                this.routeToAllInvoices()
            } catch{
                this.setErrorMessage(CONSTANTS.ERROR_MESSAGE)
            }finally{
                //Resetting Filters to default
                await this.getAllNamesForFilter()
                this.resetPoTableUserPreferences()
                this.poFiltersList.isFiltersReloaded = false
                this.resetInvoiceTableUserPreferences()
            }
        },
        showPoFilterFAQModal(dashboardType){
            this.$hhMixpanel.trackEvent(`Supplier central - Learn more on ${dashboardType} dashboard clicked`);
            this.$modal.show(PoFilterFAQModal,{},
                {name: 'PoFilterFAQModal',
                    width: 900,
                    adaptive: true,
                    height : "auto",
                    scrollable: true,
                }
                ,{
                    onClosed: () => {
                        this.$modal.hide('PoFilterFAQModal')
                    },
                })
        },
        launchSlackModal(purchaseOrder,invoice){
            document.documentElement.style.overflow = "hidden";
            this.$modal.show(SendUserToSlackModal,{postToSlackData : (purchaseOrder ? purchaseOrder : invoice)},
                {name: 'SendUserToSlackModal',
                    adaptive: true,
                    height: "auto",
                    width: "730",
                }
                ,{
                    onClosed: (success) => {
                        document.documentElement.style.overflow = "auto";
                        this.$modal.hide('SendUserToSlackModal')
                        if(success) {
                            this.$hhMixpanel.trackEvent("Vendor reached out to AccountsPayable Team for assistance");
                            this.showSuccessMessage()
                        }
                    },
                    'closeAndCancel': this.beforeClose,
                })
        },
        isValidString(str) {
          return str && str !== undefined && str !== '' && str.length > 0
        },
        beforeClose(){
            document.documentElement.style.overflow = "auto";
            this.$modal.hide('SendUserToSlackModal')
        },
        sortIgnoreCase(arrayObj) {
            return arrayObj.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
        },
        showSuccessMessage() {
            swal
                .fire({
                    title: `Message Sent`,
                    html: `Your question was posted to <a href=${CONSTANTS.ACCOUNTS_PAYABLE_SLACK} target="_blank"><strong>Accounts Payable via Lumi</strong></a>`,
                    showCancelButton: true,
                    confirmButtonText: "Launch Slack",
                    focusConfirm: false,
                    allowOutsideClick: true,
                    customClass: {
                        confirmButton: "flat-btn primary-blue-btn btn mb-3",
                        cancelButton: "flat-btn gray-btn cancel-btn btn mb-3"
                    },
                    reverseButtons: true,
                    buttonsStyling: false,
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        window.open(CONSTANTS.ACCOUNTS_PAYABLE_SLACK,"_blank")
                    }
                })
        },
    }
}